import NotFound from 'feature/NotFound/NotFoundComponent'
import Navbar from 'feature/Navbar/NavbarComponent'
// import Login from "page/Login/LoginComponent";
import Home from 'page/Home/HomeComponent'
import Library from 'page/Library/LibraryComponent'

const pathParamRoute = [
	{
		path: '/library/:bookId',
		exact: true,
		sidebar: Navbar,
		main: Library,
		title: 'Library',
	},
]

export const navbar = [
	{
		path: '/home',
		exact: true,
		sidebar: Navbar,
		main: Home,
		title: 'Home',
	},
	{
		path: '/library',
		exact: true,
		sidebar: Navbar,
		main: Library,
		title: 'Library',
	},
]

export const routes = [
	...pathParamRoute,
	...navbar,
	{
		path: '/',
		exact: true,
		sidebar: Navbar,
		main: Home,
		title: '',
	},
	{
		path: '*',
		exact: true,
		sidebar: null,
		main: NotFound,
		title: 'Not Found',
	},
]
